export default function Logo({ size = 40, withText = true }) {
  return (
    <span className="inline-flex items-center gap-3" data-testid="brand-logo">
      <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <rect width="40" height="40" rx="8" fill="#0F172A" stroke="#C5A059" strokeWidth="1.5" />
        <path d="M12 28V12L18 20L24 12V28" stroke="#F8FAFC" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M26 14C28.5 14 30 15.5 30 17.5C30 19.5 28.5 20.5 26 20.5H24" stroke="#C5A059" strokeWidth="2" strokeLinecap="round" />
        <path d="M27 20.5L30.5 28" stroke="#C5A059" strokeWidth="2" strokeLinecap="round" />
        <circle cx="20" cy="8" r="1.5" fill="#C5A059" />
      </svg>
      {withText && (
        <span className="leading-tight">
          <span className="block font-serif text-xl font-semibold tracking-wide text-slate-50">RMS Group</span>
          <span className="block font-mono text-[10px] uppercase tracking-[0.3em] text-[#C5A059]">UK Career Consultancy</span>
        </span>
      )}
    </span>
  );
}
